"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17 7.487V9h1.587a1.5 1.5 0 0 1 1.494 1.364l.818 9A1.5 1.5 0 0 1 19.405 21H4.595a1.5 1.5 0 0 1-1.494-1.636l.818-9A1.5 1.5 0 0 1 5.413 9H7V7.487c0-.743.22-1.469.632-2.086l.066-.098a5.17 5.17 0 0 1 8.606 0l.066.098c.412.618.632 1.344.632 2.086zm-8.471-1.63-.066.098a2.77 2.77 0 0 0-.464 1.532V9h8V7.487c0-.545-.161-1.078-.464-1.532l-.066-.098a4.173 4.173 0 0 0-6.942 0z"
}), 'MiniBagFilled');
